export default "__VITE_ASSET__D_Sd3hZi__"